class PasswordSlider extends HTMLElement {
  connectedCallback() {
    this._initSlider()
  }

  _initSlider() {
    $('.shop-container__slider').not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-arrow--custom slick-arrow--custom-prev"><svg width="15" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m1 1 13 14L1 29" stroke="#787878"></path></svg></button>',
      nextArrow: '<button type="button" class="slick-arrow--custom slick-arrow--custom-next"><svg width="15" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m1 1 13 14L1 29" stroke="#787878"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  }
}

try {
  window.customElements.define('password-slider', PasswordSlider);
} catch(e) {}